/*
React main component
*/
import TopNav from '../component/nav.jsx';
import Footer from '../component/footer.jsx';
import ToTop from '../component/toTop.jsx';
//import SkillBars from '../component/skillBar.jsx';
import SkillBars from '../component/skillBars2.jsx';


const SKILLS = [
  {type: "Python & Arcpy", level: 98},
  {type: "GIS & Databases", level: 97},
  {type: "Javascript & jQuery", level: 96},
  {type: "Web Development", level: 94},
  {type: "Bash", level: 93},
  {type: "CMD", level: 97},
  {type: "Powershell", level: 95},
  {type: "Ansible", level: 95 },
  // {type: "Node.js", level: 90},
  // {type: "HTML5", level: 96},
  // {type: "CSS", level: 94},
  // {type: "Bootstrap", level: 91},
  {type: "Cloud", level: 93}
];

export default class CV extends React.Component {
  constructor(props) {
    super(props);

    this.style = {};

    // this.state = {

    // };
  }

  render() {
    var content = (
      <div>
        <TopNav/>
        <div className="wrapper">
          <div className="sidebar-wrapper">
            <div className="profile-container">
              <div className="profile"/>
              <h1 className="name">Carl Flint, GISP</h1>
              <h3 className="tagline">Senior Solution Engineer</h3>
            </div>

            <div className="contact-container container-block">
              <ul className="list-unstyled contact-list">
                <li className="email">
                  <i className="fa fa-envelope"></i>
                  <a href="mailto: cflint31312@gmail.com">cflint@esri.com</a>
                </li>

                <li className="linkedin">
                  <i className="fa fa-linkedin"></i>
                  <a href="https://www.linkedin.com/in/carl-flint-gisp-ba8087121/" target="_blank">linkedin.com/in/carl-flint</a>
                </li>
                <li className="github">
                  <i className="fa fa-github"></i>
                  <a href="https://github.com/cdflint" target="_blank">github.com/cdflint</a>
                </li>
              </ul>
            </div>

            <div className="education-container container-block">
              <h2 className="container-block-title">Education</h2>
              <div className="item">
                <h4 className="degree">B.S. with Honors in Geographic Information Science</h4>
                <h5 className="degree">Honors: <i>cum laude</i><br/> Gamma Theta Upsilon</h5>
                <h5 className="meta">Salisbury University</h5>
                <div className="time">2014 - 2016</div>
              </div>

            </div>

          </div>

          <div className="main-wrapper">

            {/* <section className="section summary-section">
            <h2 className="section-title">
              <i className="fa fa-user"></i>Career Profile</h2>
            <div className="summary">
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
            </div>

          </section> */}

            <section className="section experiences-section">
              <h2 className="section-title">
                <i className="fa fa-briefcase"></i>Experiences</h2>

              <div className="item">
                <div className="meta">
                  <div className="upper-row">
                    <h3 className="job-title">Senior Solution Engineer</h3>
                    <div className="time">September 2022 - Present</div>
                  </div>

                  <div className="company">Esri</div>
                </div>

                <div className="details">
                  <p>Engage clients, solve problems, assist with leveraging the latest spatial technologies and best practices.</p>
                </div>

              </div>

              <div className="item">
                <div className="meta">
                  <div className="upper-row">
                    <h3 className="job-title">GIS Managed Cloud Tech</h3>
                    <div className="time">February 2022 - September 2022</div>
                  </div>

                  <div className="company">ROK Technologies</div>
                </div>

                <div className="details">
                  <p>Architecting, deploying and managing the ArcGIS® Enterprise suite and Desktop applications in Cloud and Hybrid environments.</p>
                </div>

              </div>

              <div className="item">
                <div className="meta">
                  <div className="upper-row">
                    <h3 className="job-title">Sr. GIS Analyst</h3>
                    <div className="time">July 2017 - February 2022</div>
                  </div>

                  <div className="company">City of Salisbury: Department of Information Services, Salisbury, MD</div>
                </div>

                <div className="details">
                  <p>Design, Develop, Analyze and maintain geo-spatial data for the City of Salisbury.  Improve data management tasks through automation and the use of generally accepted computer programming languages.</p>
                </div>

              </div>

              <div className="item">
                <div className="meta">
                  <div className="upper-row">
                    <h3 className="job-title">Administrative Officer</h3>
                    <div className="time">May 2013 - July 2017</div>
                  </div>

                  <div className="company">Worcester County Health Department, Snow Hill, MD</div>
                </div>

                <div className="details">
                  <p>Conduct health surveillance and analyze demographics data to assess community needs and to respond to infectious disease outbreaks, Geocoding of outbreak investigations, Create and maintain spatial databases, Conduct field inspections for Environmental Health Program. Perform other duties as assigned.</p>
                </div>

              </div>

              <div className="item">
                <div className="meta">
                  <div className="upper-row">
                    <h3 className="job-title">GIS Programmer</h3>
                    <div className="time">Jan. 2017 - May 2017</div>
                  </div>

                  <div className="company">Eastern Shore Regional GIS Cooperative (ESRGC), Salisbury, MD</div>
                </div>

                <div className="details">
                  <p>Develop and maintain web based applications using generally accepted computer programming languages and other development tools. Devise the most efficient method of programming in relation to program requirements and computer capabilities. Perform other duties as assigned</p>

                </div>

              </div>

              <div className="item">
                <div className="meta">
                  <div className="upper-row">
                    <h3 className="job-title">Intern</h3>
                    <div className="time">Aug. 2016 - Dec. 2016</div>
                  </div>

                  <div className="company">Wicomico County Planning &amp; Zoning Commission, Salisbury, MD</div>
                </div>

                <div className="details">
                  <p>Develop scripts and tools using generally accepted computer programming languages to reduce redundant data entry, improve data request workflow and improve productivity.</p>
                </div>

              </div>

              <div className="item">
                <div className="meta">
                  <div className="upper-row">
                    <h3 className="job-title">Remote Sensing Lab Assistant</h3>
                    <div className="time">Aug. 2016 - Dec. 2016</div>
                  </div>

                  <div className="company">Salisbury University, Salisbury, MD</div>
                </div>

                <div className="details">
                  <p>Assist Professor with in lab lecture assignments, grading lab log submissions and assignments. Mentor students in best practices of remote sensing the environment.</p>
                </div>

              </div>

              <div className="item">
                <div className="meta">
                  <div className="upper-row">
                    <h3 className="job-title">Computer Lab Assistant</h3>
                    <div className="time">Aug. 2015 - Dec. 2016</div>
                  </div>

                  <div className="company">Salisbury University, Salisbury, MD</div>
                </div>

                <div className="details">
                  <p>Assist students in overcoming obstacle with computer programs and lab assignments. Inform Professors and IT staff of issues with computer hardware and software incompatabilities.</p>
                </div>

              </div>

            </section>

            <section className="section projects-section">
              <h2 className="section-title">
                <i className="fa fa-archive"></i>Projects</h2>


                <div className="item">
                  <span className="project-title">
                    <a href="https://github.com/cdflint/patch_notification" target="_blank">ArcGIS Enterprise Patch Notification Alerts <i className="fa fa-external-link" aria-hidden="true"></i>
                    </a>
                  </span>

                  <span className="project-tagline">
                    - Tool for parsing Patch Notification utility output and generating email alerts for ArcGIS Enterprise patching.
                  </span>
                </div>

                <div className="item">
                  <span className="project-title">
                    <a href="https://opendata-salisbury.hub.arcgis.com/" target="_blank">Salisbury Open Data Hub <i className="fa fa-external-link" aria-hidden="true"></i>
                    </a>
                  </span>

                  <span className="project-tagline">
                    - Publicly accessable data application using COTS software provided by ESRI.
                  </span>
                </div>

                <div className="item">
                  <span className="project-title">
                    <a href="https://walkwicomico.com/index" target="_blank">WalkWicomico <i className="fa fa-external-link" aria-hidden="true"></i>
                    </a>
                  </span>

                  <span className="project-tagline">
                    - Custom developed Non-profit website. WalkWicomico is a coalition of community partners committed to improving walkability in Wicomico County.
                  </span>
                </div>

              <div className="item">
                <span className="project-title">
                  <a href="https://cdflint.github.io/leafletDemo/" target="_blank">Leaflet Demo <i className="fa fa-external-link" aria-hidden="true"></i>
                  </a>
                </span>

                <span className="project-tagline">
                  - A Sample web map with advanced functionality.
                </span>
              </div>

              <div className="item">
                <span className="project-title">
                  <a href="https://cdflint.github.io/arcpy-wizardry/" target="_blank">Arcpy Wizardry <i className="fa fa-external-link" aria-hidden="true"></i>
                  </a>
                </span>

                <span className="project-tagline">
                  - A continuious quality improvement project to develop tools that can be used by GIS professionals to simplify complex and repetitive tasks.
                </span>
              </div>

              <div className="item">
                <span className="project-title">
                  <a href="https://github.com/cdflint/MOISTIR" target="_blank">MOISTIR <i className="fa fa-external-link" aria-hidden="true"></i>
                  </a>
                </span>

                <span className="project-tagline">
                  - Undergraduate research project to predict temporal island retreat based on historic trends.
                </span>
              </div>

            </section>

            <section className="skills-section section">
              <h2 className="section-title">
                <i className="fa fa-rocket"></i>Skills &amp; Proficiency</h2>
              {/* Begin awesome skill bars */}
              {/* <SkillBars/> old skillbars using react-bars*/}
              <SkillBars hue="206" saturation="76" skills={SKILLS} />


            </section>
          </div>
        </div>
        <div>

        </div>
        {/* Begin footer components  */}
        <Footer/>
        <ToTop/>
      </div>

    );

    return content;
  }
};



// WEBPACK FOOTER //
// src/js/view/cv/cv.jsx